import script from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmModal.vue?vue&type=style&index=0&id=8e901d08&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e901d08"]])

export default __exports__